// extracted by mini-css-extract-plugin
export default {"notificationsThumbnail":"AtZkxe5n0jqFHd3QEF7t","positioningIcon":"L7ybNbKWxZa4NZd5kigE","notificationImage":"g6QBM_suKqBNyGxuLn3K","hoverBorder":"mr59zURUhpf8_u84QgF2"};